import { render } from "./PageViews.vue?vue&type=template&id=fb76b346"
import script from "./PageViews.vue?vue&type=script&lang=js"
export * from "./PageViews.vue?vue&type=script&lang=js"

import "./PageViews.vue?vue&type=style&index=0&id=fb76b346&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.30.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__